import styled from "styled-components";

import * as Types from "Types";

const Wrap = styled.div<Types.Default>`
   font-size: 30px;
   font-weight: 900;
   padding: 5px 20px;
   color: white;
   background-color: black;
   border-radius: 100px;
   box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.25);
   ${({ css }) => css}
`;

export default function Year(props: Types.Default) {
   return <Wrap {...props}>{props.children}</Wrap>;
}
